export const environment = {
    api_url: 'https://afiliados.seguroamericano.com.uy/api/',
    document_types_endpoint: 'document_types',
    car_brands_endpoint: 'car_brands',
    car_models_endpoint: 'car_brands/:brand_id/models',
    car_colors_endpoint: 'car_colors',
    parking_conditions_endpoint: 'parking_conditions',
    add_tag_endpoint: 'add_tag_request'
}